import * as React from "react";
import {reduxStore} from "./redux/ReduxStore";
import {Provider} from "react-redux";
import ErrorBoundary from "./components/ErrorBoundary";
import {BrowserRouter} from "react-router-dom";

const App = React.lazy(() => import("./App"));

export default function ApplicationConfigs() {

    return (
        <BrowserRouter>
            <Provider store={reduxStore}>
                <ErrorBoundary>
                    <App/>
                </ErrorBoundary>
            </Provider>
        </BrowserRouter>
    );
}
